import React from "react";

import { ColorPicker, FileInput, GradientInput, NumberInput } from "../../../../../shared/Forms";
import { renderFields } from "../helper";

const Container = () => {
	const fields = [
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FileInput
			field="backgroundImageUrl"
			id="backgroundImageUrl"
			placeholder="Background Image URL"
			themeBuilderInputType="FileInput"
		/>,
		<GradientInput
			field="backgroundGradient"
			id="backgroundGradient"
			placeholder="Gradient"
			themeBuilderInputType="GradientInput"
		/>,
		<NumberInput
			field="paddingVertical"
			id="paddingVertical"
			placeholder="Vertical Padding"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingHorizontal"
			id="paddingHorizontal"
			placeholder="Horizontal Padding"
			themeBuilderInputType="NumberInput"
		/>,
	];
	return (
		<div className="theme-columns">
			<div className="theme-column">
				<h4 className="header">Container</h4>
				<div className="theme-content">{renderFields(fields)}</div>
			</div>
		</div>
	);
};

export default Container;
